/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable prefer-template */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
import React, { useState } from 'react';
import './styles.css';
import PopData from './popData';
import { useIntl } from 'react-intl';

function Description({ webinarData })
{
	const [ anchorEl, setAnchorEl ] = useState(null);
	const [ popData, setPopData ] = useState({});
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;
	const intl = useIntl();

	const handleClick = (event, each) =>
{
		setAnchorEl(event.currentTarget);
		setPopData(each);
	};

	const handleClose = () =>
{
		setAnchorEl(null);
	};

	return (
		<div className='flexCol pdngBMD'>
			{
				webinarData?.meetingDescription &&
				<div className='flexCol pdngSM'>
					<span className='lHdng'>Description about this webinar</span>
					{/* <p>{webinarData?.meetingDescription}</p> */}
					<p>
						<div dangerouslySetInnerHTML={{ __html: webinarData?.meetingDescription }} />
					</p>
				</div>
			}
			{
				webinarData?.speakersData?.length > 0 &&
				<div className='flexCol pdngSM'>
					<span className='lHdng'>
					{intl.formatMessage({ id: 'Speakers', defaultMessage: 'Speakers' })}
					</span>
					<div className='flexWrap gap16'>
						{/* <div className='flexInline gap16 pdngVSM'>
							<img src={webinarData?.profileImage ? (webinarData?.profileImage) : '/themeAvatar2.svg'} className={webinarData?.profileImage ? 'speakerImg' : 'speakerImg pdngXXS'} alt='speaker' />
							<div className='flexAutoCol'>
								<small>Organiser</small>
								<span className='mHdng captilaizeTxt ellipsisTxt'>{webinarData?.extra.name}</span>
							</div>
						</div> */}
						{
							webinarData?.speakersData?.map((each, ind) => (
								<div key={ind} className='flexInline gap16 pdngVSM'>
									<img src={each?.speakerImage?.publicUrl ? (each?.speakerImage?.publicUrl + '/' + each?.speakerImage?.key) : '/themeAvatar2.svg'} className={each?.speakerImage?.publicUrl ? 'speakerImg' : 'speakerImg pdngXXS'} alt='speaker' />
									<div className='flexAutoCol'>
										<small>{each?.organization}</small>
										<span className='mHdng captilaizeTxt'>{each?.speakerName}</span>
										<small className='link underline' onClick={(e) => handleClick(e, each)}>View full Bio</small>
									</div>
								</div>
							))
						}
						<PopData id={id} open={open} anchorEl={anchorEl} handleClose={handleClose} webinarData={webinarData} popData={popData}/>
					</div>
				</div>
			}
		</div>
	);
}

export default Description;
